import { Icon } from '@bechtel/gds';
import { FC } from 'react';
import { AppSpinner, MultiLingualText } from '~/components';
import { ButtonStyled, ContainerStyled, FooterStyled } from './styled';
import { CommodityFooterProps } from './types';

export const CommodityFooter: FC<CommodityFooterProps> = ({
  saveHandler,
  cancelHandler,
  loading,
  disableSave,
  disableCancel,
  customButton,
  uiType = 'Form',
}) => {
  return (
    <FooterStyled>
      <ContainerStyled uiType={uiType}>
        {customButton && customButton}
        <ButtonStyled
          secondary={true}
          onClick={() => cancelHandler && cancelHandler()}
          disabled={disableCancel || loading}
        >
          <MultiLingualText>Cancel</MultiLingualText>
        </ButtonStyled>
        <ButtonStyled onClick={() => saveHandler && saveHandler()} disabled={disableSave || loading}>
          {loading ? <AppSpinner fillColor="white" /> : <Icon icon="floppy-disk" iconStyle="solid" />}
          <MultiLingualText>Save</MultiLingualText>
        </ButtonStyled>
      </ContainerStyled>
    </FooterStyled>
  );
};
